/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'
import { EstateTypeCodes } from '../enums/EstateTypeCodes.mjs'
import { TransactionCodes } from '../enums/TransactionCodes.mjs'
import EstateChargeSchema from './EstateChargeSchema.mjs'

const EstateSchema = new Schema({
  availableAt: {
    type: 'string',
    format: 'date-time'
  },
  title: {
    type: 'string',
    maxLength: 100,
    required: true
  },
  description: {
    type: 'string',
    maxLength: 3000
  },
  features: {
    type: 'array',
    items: {
      type: 'number'
    }
  },
  formalDescription: {
    type: 'string',
    maxLength: 1000
  },
  shortDescription: {
    type: 'string',
    maxLength: 255
  },
  banner: {
    type: 'string',
    maxLength: 100
  },
  bannerColor: {
    type: 'string',
    maxLength: 7,
    pattern: '#[a-fA-F0-9]{6}'
  },
  note: {
    type: 'string',
    maxLength: 1000
  },
  isPricePublished: {
    type: 'boolean'
    // required: true
  },
  price: {
    type: 'integer',
    min: 0
  },
  agencyFees: {
    type: 'integer',
    min: 0
  },
  isAgencyFeesWithTax: {
    type: 'boolean',
    required: true
  },
  securityDeposit: {
    type: 'integer',
    min: 0
  },
  Charges: {
    type: 'array',
    required: true,
    items: {
      type: EstateChargeSchema
    }
  },
  reference: {
    type: 'string',
    maxLength: 12
    // required: true,
  },
  type: {
    type: 'string',
    allowed: EstateTypeCodes,
    required: true
  },
  transaction: {
    type: 'string',
    allowed: TransactionCodes,
    required: true
  },
  tmpRef: {
    type: 'string'
  },
  exclusivity: {
    type: 'boolean'
    // required: true
  },
  cityId: {
    type: 'integer',
    required: true
  },
  ownerId: {
    type: 'integer',
    required: true
  },
  parcel: {
    type: 'string',
    maxLength: 20
  },
  published: {
    type: 'boolean'
    // required: true
  },
  publishedAt: {
    type: 'string',
    format: 'date-time'
  },
  prospectId: {
    type: 'integer'
  },
  surface: {
    type: 'integer',
    min: 0
  },
  landArea: {
    type: 'integer',
    min: 0
  },
  terraceArea: {
    type: 'integer',
    min: 0
  },
  furnished: {
    type: 'boolean'
  },
  equipped: {
    type: 'boolean'
  },
  floors: {
    type: 'integer',
    min: 0
  },
  rooms: {
    type: 'integer',
    min: 0
  },
  bedrooms: {
    type: 'integer',
    min: 0
  },
  bathrooms: {
    type: 'integer',
    min: 0
  },
  toilets: {
    type: 'integer',
    min: 0
  },
  livingRooms: {
    type: 'integer',
    min: 0
  },
  constructionYear: {
    type: 'integer'
  },
  parking: {
    type: 'number',
    min: 0
  },
  parkingNumbers: {
    type: 'string',
    maxLength: 30
  },
  residence: {
    type: 'string',
    maxLength: 100
  },
  trustee: {
    type: 'string',
    maxLength: 30
  },
  guardian: {
    type: 'string',
    maxLength: 100
  },
  gateCode: {
    type: 'string',
    maxLength: 10
  },
  kitchens: {
    type: 'integer',
    min: 0
  }
})

export default EstateSchema
